import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '@core/services/config.service';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { UserProfileService } from '../profile.services';
import { AppAlertDialogComponent } from '@core/components/alert/alert-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material';

@Component({
    selector   : 'app-profile-password',
    templateUrl: './profile-password.component.html',
    styleUrls  : ['./profile-password.component.scss']
})
export class ProfilePasswordComponent implements OnInit
{

    alertDialogRef: MatDialogRef<AppAlertDialogComponent>;
    regForm: FormGroup;
    regFormErrors: any;
    loading = false;

    constructor(private _appConfig: AppConfigService, private _router: Router,
        public dialog: MatDialog,
        private _formBuilder: FormBuilder, private _userProfile: UserProfileService) {

        this.regFormErrors = {
            password: {},
            password_confirmation : {}
        };

    }

    ngOnInit()
    {
        this.regForm = this._formBuilder.group({
            password: ['', Validators.required],
            password_confirmation: ['', [Validators.required, confirmPassword]]
        });

        this.regForm.valueChanges.subscribe(() => {
            this.onregFormValuesChanged();
        });


    }
    onregFormValuesChanged()
    {
        for ( const field in this.regFormErrors )
        {
            if ( !this.regFormErrors.hasOwnProperty(field) )
            {
                continue;
            }

            this.regFormErrors[field] = {};

            const control = this.regForm.get(field);

            if ( control && control.dirty && !control.valid )
            {
                this.regFormErrors[field] = control.errors;
            }
        }
    }


    onSubmit(){
        if (this.regForm.valid) {
            this.loading = true;
            const data = this.regForm.getRawValue();
            this._userProfile.reset_password(data)
            .then((res: any) => {
                this.loading = false;
                this.alert();
            }).catch ((err: any) => {
                this.loading = false;
            });

        }

    }
    alert()
    {
        this.alertDialogRef = this.dialog.open(AppAlertDialogComponent, {
            disableClose: false
        });

        this.alertDialogRef.componentInstance.alertMessage = 'Contraseña actualizada';

        this.alertDialogRef.afterClosed().subscribe(result => {

            this.alertDialogRef = null;
        });

    }


}





function confirmPassword(control: AbstractControl) {
    if (!control.parent || !control) {
        return;
    }


    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('password_confirmation');

    if (!password || !passwordConfirm) {
        return;
    }

    if (passwordConfirm.value === '') {
        return;
    }

    if (password.value !== passwordConfirm.value) {
        return {
            passwordsNotMatch: true
        };
    }
}
